module.exports = __webpack_public_path__ + "static/img/b2b_logo.ca02269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b2b_logo.png
// module id = //1N
// module chunks = 1